const euroFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

const numberFormatter = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 })
const decimalFormatter = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 1, minimumFractionDigits: 1 })

export function euro(value: number): string {
  return euroFormatter.format(Math.round(value))
}

export function num(value: number): string {
  return numberFormatter.format(value)
}

export function dec(value: number): string {
  return decimalFormatter.format(value)
}
